class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.onClickHandler = this.onClickHandler.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);

    this.addEventListener('click', this.onClickHandler);

    if (this.dataset.trigger === 'infinite') {
      this.observer = new IntersectionObserver(this.handleIntersection, {
        rootMargin: '0px 0px 200px 0px'
      });
      this.observer.observe(this);
    }
  }

  onClickHandler() {
    if (this.classList.contains('loading')) return;

    this.classList.add('loading');

    const sections = InfiniteScroll.getSections();
    const url = this.dataset.url;

    Promise.all(
      sections.map(() => InfiniteScroll.renderSectionFromFetch(url))
    ).then(() => {
      this.classList.remove('loading');
      this.classList.remove('disabled'); // Removed 'disabled' to allow repeated triggers
      if (this.dataset.trigger === 'infinite') {
        this.observer.observe(this); // Re-observe to enable infinite looping
      }
    }).catch((e) => {
      console.error(e);
      this.classList.remove('loading');
    });
  }

  handleIntersection(entries) {
    if (!entries[0].isIntersecting) return;

    this.observer.unobserve(this); // Prevent multiple triggers while loading
    this.onClickHandler();
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ];
  }

  static renderSectionFromFetch(url) {
    return fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        InfiniteScroll.renderPagination(html);
        InfiniteScroll.renderProductGridContainer(html);
      });
  }

  static renderPagination(html) {
    const container = document.getElementById('ProductGridContainer')?.querySelector('.pagination-wrapper');
    const pagination = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer')
      ?.querySelector('.pagination-wrapper');

    if (pagination && container) {
      container.innerHTML = pagination.innerHTML;
    } else if (container) {
      container.remove();
    }
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('product-grid');
    const products = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('product-grid');

    if (products && container) {
      container.insertAdjacentHTML('beforeend', products.innerHTML);
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
